var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunchGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "156px",
    height: "156px",
    viewBox: "0 0 156 156",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.562446,0.437554159 C143.108146,0.437554159 147.211094,2.33320048 150.123892,5.37709539 C153.1668,8.28890642 155.062446,12.3918543 155.062446,16.9375542 L155.062446,114.937554 C155.062446,123.77411 147.899002,130.937554 139.062446,130.937554 C130.22589,130.937554 123.062446,123.77411 123.062446,114.937554 L123.06238,55.0635542 L27.6845058,150.442911 C21.4361172,156.6913 11.3054775,156.6913 5.05708883,150.442911 C-1.19129983,144.194522 -1.19129983,134.063883 5.05708883,127.815494 L100.43438,32.4365542 L40.5624458,32.4375542 C31.7258898,32.4375542 24.5624458,25.2741102 24.5624458,16.4375542 C24.5624458,7.60099816 31.7258898,0.437554159 40.5624458,0.437554159 L138.562446,0.437554159 Z",
    id: "Combined-Shape",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchGlyph);
export default __webpack_public_path__ + "static/media/launch_glyph.3414f47ff22eee1b03f33bee112e1c10.svg";
export { ForwardRef as ReactComponent };